// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetCurrencyQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetCurrencyQuery = { __typename?: 'Query' } & {
  currency: Types.Maybe<{ __typename?: 'Currency' } & Pick<Types.Currency, 'id' | 'name'>>;
};

export const GetCurrencyDocument = /*#__PURE__*/ gql`
    query getCurrency($id: ID!) {
  currency(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetCurrencyQuery__
 *
 * To run a query within a React component, call `useGetCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrencyQuery(
  baseOptions: Apollo.QueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables> &
    ({ variables: GetCurrencyQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, options);
}
export function useGetCurrencyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, options);
}
// @ts-expect-error
export function useGetCurrencySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCurrencyQuery, GetCurrencyQueryVariables>;
export function useGetCurrencySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCurrencyQuery | undefined, GetCurrencyQueryVariables>;
export function useGetCurrencySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyQuery, GetCurrencyQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCurrencyQuery, GetCurrencyQueryVariables>(GetCurrencyDocument, options);
}
export type GetCurrencyQueryHookResult = ReturnType<typeof useGetCurrencyQuery>;
export type GetCurrencyLazyQueryHookResult = ReturnType<typeof useGetCurrencyLazyQuery>;
export type GetCurrencySuspenseQueryHookResult = ReturnType<typeof useGetCurrencySuspenseQuery>;
